export enum PackageTypes {
  "Envelope" = 1,
  "Pak" = 2,
  "Parcel" = 3,
}
